import React from 'react';
import { compose, join, juxt, toUpper, head, tail } from 'ramda';

import RichText from '@synergycms_core/components/generic/RichText';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './Link.js';
import Image from '@synergycms_core/components/generic/Image';
import { withContent } from '../../providers/translateProvider';
import format from 'string-template';


const capitalize = compose(
  join(''),
  juxt([
    compose(
      toUpper,
      head
    ),
    tail
  ])
);

const Link = class Link extends React.Component {
  constructor(props) {
    super(props);
    this.styleFile = styleFile;
  }
  static displayName = 'Link';




  render() {
    const { config, theme, content } = this.props;

    const quantityOrPlural = typeof config.quantity === 'number' ? config.quantity : config.plural || false;

    let text = config.title || config.richText.text;

    if (text && content) {
      text = content.t(text, quantityOrPlural);

      if (config.withVars) {
        let translatedWithVars = {};
        Object.keys(config.withVars).forEach(key => {
          translatedWithVars[key] = content.t(config.withVars[key]);
        });

        text = format(text, translatedWithVars);
      }
    }

    if (text && config.ucFirst) {
      text = capitalize(text.toString());
    }

    return (
      <a
        className={theme.computedInnerStyle}
        href={config.href || null}
        target={config.target}
        title={text}
        rel="noopener">
        {config.image && <Image config={config.image} />}
        <RichText config={config.richText}>{config.text}</RichText>
      </a>
    );
  }
};

export default compose(
  PropertyManager(['config', 'href', 'title', 'text', 'richText', 'image', 'target']),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(Link);
